import { render, staticRenderFns } from "./ParticipantComponent.vue?vue&type=template&id=76c3ca72&"
import script from "./ParticipantComponent.vue?vue&type=script&lang=js&"
export * from "./ParticipantComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports